"use strict";

exports.__esModule = true;
exports.DataTable = DataTable;
exports.calculateRowsForHeight = calculateRowsForHeight;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactTable = _interopRequireDefault(require("react-table"));
require("react-table/react-table.css");
var _DataTableToolbar = require("./DataTableToolbar");
var _fetchAlertPages = require("./fetchAlertPages");
var _ColumnHeader = require("./ColumnHeader");
var _manualDataUpdate = require("./manualDataUpdate");
var _migrateFilteredForExactMatch = require("./migrateFilteredForExactMatch");
var _Translator = require("../Translator");
var _DataTableContextMenu = require("../../Widgets/DataTable/DataTableContextMenu");
var _getRowStyles = require("./getRowStyles");
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _URLFilter = require("../URLFilter");
var _API = require("../../API");
var _AsyncLoader = require("../AsyncLoader");
var _DeviceListLoader = require("../../Device/DeviceListContext/DeviceListLoader");
var _System = require("../../../System");
var _Theme = require("../../Theme");
var _UI = require("../../../Utils/UI");
var _excluded = ["columns", "data", "defaultSorted", "defaultFiltered", "height", "width", "applyPagination", "SubComponent", "rowFormatters", "onRowClick", "selectedRowIndex", "resetSelectedRowIndex", "noDataText", "getDataForCSV", "reload", "showReloadButton", "showDownloadButton", "showDownloadDropdownButton", "editButtonComponent", "sortedState", "setSortedState", "handleSearchTextChange", "searchText", "additionalToolbarSelectors"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var HEADER_SIZE = 27;
var TOOLBAR_SIZE = 34;
var FOOTER_SIZE = 43;
var ROW_SIZE = 32;
function calculateRowsForHeight(height) {
  return Math.floor((height - TOOLBAR_SIZE - HEADER_SIZE - FOOTER_SIZE) / ROW_SIZE);
}
var ScrollWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DataTable__ScrollWrapper",
  componentId: "sc-14l04i7-0"
})(["width:100%;height:100%;min-width:0;overflow:auto;.ReactTable .rt-table{container-type:inline-size;}.ReactTable .rt-table .rt-thead.-headerGroups{position:sticky;left:0;width:100cqw;}.ReactTable .rt-tr{min-width:100%;}.ReactTable .rt-thead.-headerGroups .rt-tr{width:100%;}.ReactTable .rt-thead.-headerGroups .rt-th,.ReactTable .rt-thead.-headerGroups .rt-td{flex:1 1 auto !important;width:100% !important;max-width:none !important;overflow:visible;display:flex;justify-content:flex-start;text-align:left;}.ReactTable .rt-thead.-headerGroups .rt-th:not(:last-child){display:none;}.ReactTable .rt-thead.-filters{display:none;}.ReactTable .rt-resizer{width:10px;right:-5px;}.ReactTable .rt-thead.-header .rt-th .", "{width:100%;display:flex;flex:1;}.ReactTable .rt-thead .rt-th.-sort-desc,.ReactTable .rt-thead .rt-td.-sort-desc{box-shadow:none;}.ReactTable .rt-thead .rt-th.-sort-asc,.ReactTable .rt-thead .rt-td.-sort-asc{box-shadow:none;}.ReactTable .-pagination{.-center{min-width:250px;}.-pageInfo{margin:3px 0 3px 5px;}.-pageSizeOptions{margin:3px 5px;}.-btn{color:", ";}input,select{color-scheme:light;}}"], _core.Classes.POPOVER_TARGET, (0, _Theme.val)("TextColor"));
var ALERTS_PAGE_URL = (0, _System.getScreenPath)("AlertList");
var TICKETS_PAGE_URL = (0, _System.getScreenPath)("TicketList");
function DataTable(props) {
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var location = (0, _reactRouterDom.useLocation)();
  var urlFilter = (0, _react.useContext)(_URLFilter.URLFilterContext);
  var restApi = (0, _react.useContext)(_API.RestAPIContext);
  var columns = props.columns,
    data = props.data,
    defaultSorted = props.defaultSorted,
    defaultFiltered = props.defaultFiltered,
    height = props.height,
    width = props.width,
    applyPagination = props.applyPagination,
    SubComponent = props.SubComponent,
    rowFormatters = props.rowFormatters,
    onRowClick = props.onRowClick,
    selectedRowIndex = props.selectedRowIndex,
    resetSelectedRowIndex = props.resetSelectedRowIndex,
    noDataText = props.noDataText,
    getDataForCSV = props.getDataForCSV,
    reload = props.reload,
    showReloadButton = props.showReloadButton,
    showDownloadButton = props.showDownloadButton,
    showDownloadDropdownButton = props.showDownloadDropdownButton,
    editButtonComponent = props.editButtonComponent,
    sortedState = props.sortedState,
    setSortedState = props.setSortedState,
    handleSearchTextChange = props.handleSearchTextChange,
    searchText = props.searchText,
    additionalToolbarSelectors = props.additionalToolbarSelectors,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var reloaded = true;
  var rawData = undefined;
  var csvDeviceList = undefined;
  var _useState = (0, _react.useState)(false),
    csvDownloading = _useState[0],
    setCsvDownloading = _useState[1];
  var _useState2 = (0, _react.useState)(defaultSorted || []),
    sorted_ = _useState2[0],
    setSorted_ = _useState2[1];
  var sorted = sortedState || sorted_;
  var setSorted = setSortedState || setSorted_;
  var _useState3 = (0, _react.useState)(defaultFiltered || []),
    filtered = _useState3[0],
    setFiltered = _useState3[1];
  var _useState4 = (0, _react.useState)(searchText ? searchText : ""),
    searchTerm = _useState4[0],
    setSearchTerm = _useState4[1];
  (0, _react.useEffect)(function () {
    setFiltered(function (current) {
      return (0, _migrateFilteredForExactMatch.migrateFilteredForExactMatch)(current, columns);
    });
  }, [columns]);

  // When filters or sorted is updated, the selected row should be un-set, since it may not be visible after the filter
  (0, _react.useEffect)(function () {
    if (resetSelectedRowIndex) {
      resetSelectedRowIndex();
    }
  }, [filtered, sorted]);
  var handleSearchTermChange = function handleSearchTermChange(value) {
    handleSearchTextChange ? handleSearchTextChange(value) : setSearchTerm(value);
  };
  var updatedData = props.manual || props.manualSearch ? (0, _manualDataUpdate.manualDataUpdate)(columns, data, sorted, filtered, searchTerm) : data;
  var cols = (0, _react.useMemo)(function () {
    return columns.map(function (col) {
      var table = Object.assign({}, col, {
        accessor: col.id,
        Header: /*#__PURE__*/_react["default"].createElement(_ColumnHeader.ColumnHeader, {
          key: col.name,
          icon: col.icon,
          header: col.name,
          titleOverridden: col.titleOverridden,
          Cell: col.Cell,
          DownloadCellFormatter: col.DownloadCellFormatter,
          accessor: col.id,
          canSort: col.canSort,
          canFilter: col.canFilter,
          canSearch: col.canSearch,
          exactMatch: col.exactMatch,
          sorted: sorted,
          setSorted: setSorted,
          filtered: filtered,
          setFiltered: setFiltered,
          data: data
        })
      });
      if (col.id === "actions") {
        table.Cell = function (_ref) {
          var _urlFilter$filters$pe, _urlFilter$filters$pe2;
          var value = _ref.value;
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end"
            }
          }, col.actionsComponent({
            values: value,
            reload: reload,
            dateRange: {
              start: (_urlFilter$filters$pe = urlFilter.filters.period) == null ? void 0 : _urlFilter$filters$pe.split("/")[0],
              end: (_urlFilter$filters$pe2 = urlFilter.filters.period) == null ? void 0 : _urlFilter$filters$pe2.split("/")[1]
            }
          }));
        };
      }
      return table;
    });
  }, [columns, sorted, filtered]);
  var getRawDataForCSV = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(deviceList) {
      var _urlFilter$filters$pe3;
      var devices, period, _yield$fetchAlertPage, rows, truncated, metadata;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            devices = urlFilter.filters.device;
            period = (_urlFilter$filters$pe3 = urlFilter.filters.period) == null ? void 0 : _urlFilter$filters$pe3.split("/");
            if (!(location.pathname === ALERTS_PAGE_URL)) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return (0, _fetchAlertPages.fetchAlertPages)(function (page, size) {
              return restApi.get((0, _fetchAlertPages.alertPageUrl)({
                start: period[0],
                end: period[1],
                devices: devices,
                page: page,
                size: size
              }));
            });
          case 1:
            _yield$fetchAlertPage = _context.v;
            rows = _yield$fetchAlertPage.rows;
            truncated = _yield$fetchAlertPage.truncated;
            if (truncated) {
              (0, _UI.showWarningToaster)(translate("DataTable.Alerts.truncatedExport", "This export stops at 100000 alerts. The period has more."));
            }
            return _context.a(2, rows.map(function (item) {
              var _deviceList$data;
              return Object.assign({}, item, {
                deviceId: item.device.value,
                deviceName: deviceList == null || (_deviceList$data = deviceList.data) == null || (_deviceList$data = _deviceList$data.find(function (device) {
                  return device.uuid === item.device.value;
                })) == null ? void 0 : _deviceList$data.name
              });
            }));
          case 2:
            if (!(location.pathname === TICKETS_PAGE_URL)) {
              _context.n = 5;
              break;
            }
            _context.n = 3;
            return restApi.get("/api/v1/ticketing/ticket?comments=true&overlapping=" + encodeURIComponent(period.join(";")) + "&deviceUuids=" + encodeURIComponent(devices.join(";")) + "&page=0&size=1");
          case 3:
            metadata = _context.v;
            _context.n = 4;
            return restApi.get("/api/v1/ticketing/ticket?comments=true&overlapping=" + encodeURIComponent(period.join(";")) + "&deviceUuids=" + encodeURIComponent(devices.join(";")) + "&page=0&size=" + metadata.totalElements);
          case 4:
            return _context.a(2, _context.v.content.map(function (responseData) {
              var _responseData$history, _responseData$history2;
              var getAge = function getAge(lastUpdate) {
                return lastUpdate - new Date(responseData.created).valueOf();
              };
              var lastItemIndex = ((_responseData$history = responseData.history) == null ? void 0 : _responseData$history.length) - 1;
              responseData.updated = lastItemIndex >= 0 ? (_responseData$history2 = responseData.history[lastItemIndex]) == null ? void 0 : _responseData$history2.timestamp : undefined;
              return {
                created: responseData.created,
                updated: responseData.updated,
                description: responseData.description,
                devices: responseData.devices,
                links: (responseData.links || []).join(", "),
                id: responseData.id,
                status: responseData.status,
                title: responseData.title,
                age: responseData.status === "CLOSED" ? getAge(Date.parse(responseData.updated)) : getAge(Date.now().valueOf()),
                creator: responseData.creatorId,
                assignee: responseData.assigneeId || "",
                types: responseData.type,
                comments: responseData.comments || [],
                priority: responseData.priority
              };
            }));
          case 5:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getRawDataForCSV(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var loadCsvData = function loadCsvData(deviceList) {
    csvDeviceList = deviceList;
    if (location.pathname === ALERTS_PAGE_URL) {
      return undefined;
    }
    return getRawDataForCSV(deviceList);
  };
  var exportFetchedRows = function exportFetchedRows(rows) {
    (0, _DataTableContextMenu.downloadTableData)(cols, (0, _manualDataUpdate.manualDataUpdate)(columns, rows || [], sorted, filtered, searchTerm), getDataForCSV);
  };
  var tableHeader = [{
    Header: /*#__PURE__*/_react["default"].createElement(_DataTableToolbar.DataTableToolbar, {
      handleSearchTermChange: handleSearchTermChange,
      reload: reload,
      downloading: csvDownloading,
      downloadTableData: function downloadTableData(timeFormat) {
        if (location.pathname === ALERTS_PAGE_URL) {
          setCsvDownloading(true);
          return getRawDataForCSV(csvDeviceList).then(exportFetchedRows)["finally"](function () {
            return setCsvDownloading(false);
          });
        }
        if (location.pathname === TICKETS_PAGE_URL) {
          exportFetchedRows(rawData);
          return;
        }
        (0, _DataTableContextMenu.downloadTableData)(cols, updatedData, getDataForCSV != null ? function () {
          return getDataForCSV(cols, updatedData, timeFormat);
        } : undefined);
      },
      showReloadButton: showReloadButton,
      showDownloadButton: showDownloadButton,
      showDownloadDropdownButton: showDownloadDropdownButton,
      editButtonComponent: editButtonComponent,
      additionalSelectors: additionalToolbarSelectors
    }),
    columns: cols
  }];
  var tableProps = {
    columns: tableHeader,
    sortable: false,
    filterable: false,
    getTrProps: function getTrProps(_, rowInfo) {
      return {
        style: (0, _getRowStyles.getRowStyles)(theme, rowInfo, rowFormatters)
      };
    },
    getTdProps: function getTdProps(_, rowInfo) {
      return {
        onClick: function onClick(event, handleOriginal) {
          if (onRowClick) {
            onRowClick(rowInfo);
          }

          // Handle original is sort of like super()
          if (handleOriginal) {
            handleOriginal();
          }
        },
        style: (0, _getRowStyles.getRowStyles)(theme, rowInfo, undefined, selectedRowIndex, onRowClick)
      };
    }
  };
  if (SubComponent) {
    // TODO: figure this out!
    // $FlowFixMe
    tableProps.SubComponent = function (rowData) {
      return /*#__PURE__*/_react["default"].createElement(SubComponent, {
        width: width,
        height: height,
        rowData: rowData
      });
    };
  }
  if (props.manual) {
    return /*#__PURE__*/_react["default"].createElement(_DeviceListLoader.DeviceListLoader, null, function (deviceList) {
      return /*#__PURE__*/_react["default"].createElement(_AsyncLoader.AsyncLoader, {
        load: function load() {
          return loadCsvData(deviceList);
        }
      }, function (rawDataProps) {
        if (reloaded) {
          reloaded = false;
          rawDataProps.reload();
        }
        rawData = rawDataProps.data;
        return /*#__PURE__*/_react["default"].createElement(ScrollWrapper, {
          "data-testid": "DataTable.Wrapper"
        }, /*#__PURE__*/_react["default"].createElement(_reactTable["default"], _extends({}, extra, noDataText ? {
          noDataText: translate("DataTable.NoDataText", noDataText)
        } : {}, tableProps, {
          showPagination: true,
          previousText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "DataTable.Labels.Previous",
            defaultMessage: "Previous"
          }),
          nextText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "DataTable.Labels.Next",
            defaultMessage: "Next"
          }),
          pageText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "DataTable.Labels.Page",
            defaultMessage: "Page"
          }),
          rowsText: translate("DataTable.Labels.rows", "rows"),
          manual: true,
          data: applyPagination ? applyPagination(updatedData) : updatedData,
          getTbodyProps: function getTbodyProps() {
            return {
              onContextMenu: function onContextMenu(e) {
                if (!props.hideContextMenu) location.pathname === ALERTS_PAGE_URL ? (0, _DataTableContextMenu.showDataTableContextMenu)({
                  e: e,
                  translator: translate,
                  columns: cols,
                  loadData: function loadData() {
                    return getRawDataForCSV(csvDeviceList);
                  },
                  getDataForCSV: getDataForCSV
                }) : location.pathname === TICKETS_PAGE_URL ? (0, _DataTableContextMenu.showDataTableContextMenu)({
                  e: e,
                  translator: translate,
                  columns: cols,
                  data: rawData,
                  getDataForCSV: getDataForCSV
                }) : (0, _DataTableContextMenu.showDataTableContextMenu)({
                  e: e,
                  translator: translate,
                  columns: cols,
                  data: data,
                  getDataForCSV: getDataForCSV
                });
              }
            };
          }
        })));
      });
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_DeviceListLoader.DeviceListLoader, null, function (deviceList) {
    return /*#__PURE__*/_react["default"].createElement(_AsyncLoader.AsyncLoader, {
      load: function load() {
        return loadCsvData(deviceList);
      }
    }, function (rawDataProps) {
      if (reloaded) {
        reloaded = false;
        rawDataProps.reload();
      }
      rawData = rawDataProps.data;
      return /*#__PURE__*/_react["default"].createElement(ScrollWrapper, {
        "data-testid": "DataTable.Wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_reactTable["default"], _extends({}, extra, noDataText ? {
        noDataText: translate("DataTable.NoDataText", noDataText)
      } : {}, {
        data: updatedData
      }, tableProps, {
        sorted: sorted,
        filtered: filtered,
        style: {
          height: height,
          width: width
        },
        getTbodyProps: function getTbodyProps() {
          return {
            onContextMenu: function onContextMenu(e) {
              if (!props.hideContextMenu) location.pathname === ALERTS_PAGE_URL ? (0, _DataTableContextMenu.showDataTableContextMenu)({
                e: e,
                translator: translate,
                columns: cols,
                loadData: function loadData() {
                  return getRawDataForCSV(csvDeviceList);
                },
                getDataForCSV: getDataForCSV
              }) : location.pathname === TICKETS_PAGE_URL ? (0, _DataTableContextMenu.showDataTableContextMenu)({
                e: e,
                translator: translate,
                columns: cols,
                data: rawData,
                getDataForCSV: getDataForCSV
              }) : (0, _DataTableContextMenu.showDataTableContextMenu)({
                e: e,
                translator: translate,
                columns: cols,
                data: updatedData,
                getDataForCSV: getDataForCSV
              });
            }
          };
        }
      })));
    });
  });
}